import api from '@/services/api'

export default {
    fetchAlbums(params) {
        return api.get(`albums/`, {params})
            .then(response => response.data)
    },
    fetchMoveAlbums(params) {
        return api.get(`albums/move_list/`, {params})
            .then(response => response.data)
    },
    getAlbumDetail(album_id) {
        return api.get(`albums/${album_id}/`)
            .then(response => response.data)
    },
    postAlbum(album_data) {
        return api.post(`albums/`, album_data)
            .then(response => response.data)
    },
    editAlbum(album_data) {
        return api.put(`albums/${album_data.id}/`, album_data)
            .then(response => response.data)
    },
    deleteAlbum(album_id) {
        return api.delete(`albums/${album_id}/`)
    },
    totalAlbum(album_id) {
        return api.get(`albums/${album_id}/total/`)
            .then(response => response.data)
    },
    sendToPurchase(data) {
        return api.put(`albums/${data.album_id}/send_to_purchase/`, data)
            .then(response => response.data)
    },
    getDeliveryInfos(params) {
        return api.get(`albums/delivery_infos/`, {params})
            .then(response => response.data)
    },
}